import React, { Component } from 'react';
import { View, Text, TouchableOpacity,Dimensions } from 'react-native';
import { DeviceInfo } from 'qunar-react-native';
import { inject, observer } from 'mobx-react/native';
import { STATUS_BAR_DATA_MAP, DefaultConfigItemModel } from '../../Constant/statusBarData';
import Icon from '../Icon';
import styles from './style';
import { RootStoreInterface } from '../../Store/index';
import { qav } from '../../Utils/qav';
import PPLogUtil from '../../Utils/PPLogUtil';
import { Colors } from '@qnpm/q-theme';

const { scenes: { baseColor } } = Colors;

interface Props {
    curBusinessId?: string;
    businessValue?:string;
    curStatusId?: string;
    inLoading?: boolean;
    filterBarBgColor?: string;
    tabBgColor?: string;
    tabsPaddingHorizontal?:number;
    tabItemSelectedBgColor?: string;
    tabItemSelectedTitleColor?: string;
    tabItemUnSelctedBgColor?: string;
    tabItemUnSelctedTitleColor?: string;
    sourceFrom?:string;
    deviceWidth?: number;
    changeStatus?(statusFilter: string, businessId?: string): void;
    scrollTopAndInit?(isCold?: boolean, isFirstLoad?: boolean): void;
    orderSearchEntry:any;
}

@inject((store: RootStoreInterface) => ({
    curBusinessId: store.uiState.businessId,
    businessValue:store.uiState.businessValue,
    curStatusId: store.uiState.statusFilter,
    inLoading: store.orderlist.inLoading,
    changeStatus: store.changeStatus,
    scrollTopAndInit: store.orderlist.scrollTopAndInit,
    sourceFrom:store.uiState.sourceFrom,
    deviceWidth: store.size.deviceWidth,
    orderSearchEntry: store.orderlist.orderSearchEntry
}))
@observer
class StatusBar extends Component<Props> {
    componentDidMount(): void {
        this.qavQmember('show','search');
    }
    /**
     * 根据传入的状态栏id获取索引
     */
    public getStatusIndexById = (statusBarData: DefaultConfigItemModel[], statusId: string) => {
        const len = statusBarData.length;
        for (let i = 0; i < len; i++) {
            if (statusId === statusBarData[i].id) {
                return i;
            }
        }
        return -1;
    };

    public onStatusItemTap = (statusId: string, title: string, index: number) => {
        const { inLoading, changeStatus, scrollTopAndInit, curStatusId } = this.props;
        if (inLoading) {
            return;
        }

        if (statusId === curStatusId) {
            return;
        }

        changeStatus(statusId);
        scrollTopAndInit();

        const extObject = {
            type: 'tab',
            source:this.props.sourceFrom || ''
        };
        PPLogUtil.orderHeadClickLog(title, extObject);

        qav({
            page: 'order_rn_main',
            module: 'statusBtn',
            path: [
                {
                    title,
                    position: index
                }
            ],
            operType: 'click',
            source:this.props.sourceFrom,
        });
    };
    public searchJump = () => {
        const { curStatusId, curBusinessId, businessValue, sourceFrom } = this.props;
        Ext.Router.Bridge.sendScheme({
            url: `${DeviceInfo.scheme}://react/open?hybridId=commonbusiness_rn&pageName=OrderSearchPage&initProps=%7B%22param%22%3A%7B%22sourceFrom%22%3A%22${sourceFrom}%22%2C%22businessValue%22%3A%22${businessValue}%22%2C%22orderStatus%22%3A%22${curStatusId}%22%7D%7D`
        }, () => null);
    }
    qavQmember = (operType:string,id:string) => {
        const qavJson = {
            ext:{},
            bizType: 'pp',
            module: 'list',
            appcode:'cmn_order_rn,cmn_component_order',
            page: 'orderList',
            id,
            operType,
            key:`pp/orderList/list/${operType}/${id}`,
            operTime: new Date().getTime().toString()
        };
        qav(qavJson);
    }
    public render() {
        const { curStatusId, curBusinessId, deviceWidth, orderSearchEntry } = this.props;
        if (!curBusinessId) {
            return null;
        }
        const curStatusBarData = STATUS_BAR_DATA_MAP[curBusinessId];
        const curStatusIndex = this.getStatusIndexById(curStatusBarData, curStatusId);
        const w = (deviceWidth - (curStatusBarData.length - 1) * 13 - this.props.tabsPaddingHorizontal * 2)/(curStatusBarData.length)
        return (
            <View style={[styles.statusBar,{backgroundColor:this.props.tabBgColor,paddingHorizontal:this.props.tabsPaddingHorizontal}]}>
                {/* 订单搜索入口 */}
                {
                   orderSearchEntry() && (
                        <TouchableOpacity
                            activeOpacity={1}
                            style={styles.searchBar}
                            onPress={() => {
                                this.searchJump();
                                this.qavQmember('click','search');
                            }}
                        >
                            <Icon code="&#xf0fd;" style={styles.searchIcon} />
                            <Text style={styles.searchText}>输入关键字、目的地、出行人姓名</Text>
                        </TouchableOpacity>
                    )
                }
                <View style={styles.selectBar}>
                {curStatusBarData.map(({ id, title, tag }, index) => (
                    <TouchableOpacity
                        activeOpacity={1}
                        key={id}
                        style={styles.statusBarItemWrapper}
                        onPress={() => {
                            this.onStatusItemTap(id, title, index);
                        }}
                        {...global.orderAccessibilityLabel(tag)}
                    >

                        <View style={[styles.normalBg,
                            // {marginRight:index === curStatusBarData.length-1?0:11},
                            {backgroundColor:curStatusIndex === index?this.props.tabItemSelectedBgColor:this.props.tabItemUnSelctedBgColor},
                            { width: title === '退款/售后' ? w + 12 : w, borderWidth: curStatusIndex === index ? 0.5 : 0, borderColor: curStatusIndex === index ? baseColor.brand : 'rgba(0,0,0,0)' }
                        ]}>
                            <Text style={[
                                styles.title,
                                {color:curStatusIndex === index ? this.props.tabItemSelectedTitleColor:this.props.tabItemUnSelctedTitleColor},
                                {fontWeight:curStatusIndex === index ?'600':'300'},
                                ]} numberOfLines={1}>{title}</Text>
                        </View>
                    </TouchableOpacity>
                ))}
                </View>
            </View>
        );
    }
}

export default StatusBar;
